module.exports = require('./DepBankAcquisitionMergerFilingView');
